module.exports = require('./DepBankAcquisitionMergerFilingView');
